export default __webpack_public_path__ + "static/media/slot-icon-active.c0a5a60a.webp";